import { Button, Typography } from "@mui/material";
import Box from "@mui/material/Box/Box";
import { useNavigate } from "react-router-dom";
import LoginIcon from "@mui/icons-material/Login";
import ClientIcon from "../../../../assets/img/cuttedHair.png";
import SalonIcon from "../../../../assets/img/salon.png";
import styles from "./styles";
import Footer from "../../../../components/general/Footer";
import { PrimaryButton } from "@/components/general/buttons/PrimaryButton";
import { useAuth } from "@/context/AuthProvider/useAuth";
import { useTranslation } from "react-i18next";

const BeautyLandingPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { logout } = useAuth();

  const firstSection = (
    <section style={styles.firstSectionContainer}>
      <Box sx={styles.firstSectionHeader}>
        <Box sx={{ marginLeft: "15px" }}>
          <Typography variant="h5" fontWeight="bold">
              {t("landingPage.beauty.headerTitle")}
          </Typography>
        </Box>
        <Box sx={styles.alreadyRegisteredContainer}>
          <Typography sx={styles.alreadyRegisteredLabel}>
              {t("landingPage.common.headers.alreadyAccount")}
          </Typography>
          <Button
            sx={styles.loginButton}
            disableElevation
            variant="outlined"
            onClick={() => {
              logout();
              navigate("/login");
            }}
          >
              {t("landingPage.common.headers.login")}
          </Button>
        </Box>
      </Box>
      <Box sx={styles.presentationContainer}>
        <Typography variant="h4" fontWeight="bold">
            {t("landingPage.beauty.hero.titlePrefix")}
          <Typography
            sx={{ color: "secondary.main", marginLeft: "8px" }}
            variant={"span"}
            fontWeight="bold"
          >
              {t("landingPage.beauty.hero.titleHighlight")}
          </Typography>
        </Typography>

        <Typography variant="h6" fontWeight="regular">
            {t("landingPage.beauty.hero.subtitle")}
        </Typography>

        <Box>
          <PrimaryButton
            label={t("landingPage.common.buttons.register")}
            icon={<LoginIcon />}
            onClickAction={() => navigate("/register")}
          />
        </Box>
      </Box>
    </section>
  );

  const secondSection = (
    <section style={styles.secondSectionContainer}>
      <Box sx={styles.secondSectionHeader}>
        <Typography variant="h5" fontWeight="bold">
            {t("landingPage.beauty.roles.sectionTitle")}
        </Typography>
        <Typography>{t("landingPage.common.roles.subtitle")}</Typography>
      </Box>
      <Box sx={styles.roleCardContainer}>
        <Box sx={styles.roleCard}>
          <img
            src={ClientIcon}
            alt="Client icon"
            style={styles.roleCardImage}
          />
          <Typography variant="h6" fontWeight="bold">
              {t("landingPage.common.roles.clientTitle")}
          </Typography>
          <Typography>
              {t("landingPage.beauty.roles.clientDesc")}
          </Typography>
        </Box>
        <Box sx={styles.roleCard}>
          <img
            src={SalonIcon}
            alt="Pet Manager icon"
            style={styles.roleCardImage}
          />
          <Typography variant="h6" fontWeight="bold">
              {t("landingPage.common.roles.commercialTitle")}
          </Typography>
          <Typography>
              {t("landingPage.common.roles.commercialDesc")}
          </Typography>
        </Box>
      </Box>
    </section>
  );

  {
    /* <Helmet>
        <title>
          Demandoria | Agende os melhores serviços sem sair de casa!
        </title>
        <meta
          name="description"
          content="Revolucione sua forma de agendar serviços com o Demandoria! Nós oferecemos um agendamento rápido e prático para uma variedade de serviços. Encontre e reserve os melhores profissionais, tudo isso sem sair de casa. Experimente hoje mesmo."
        />
        <meta
          name="keywords"
          content="ecommerce, services, schedule, agendamento de serviços, agendar online, demandoria, serviços, marketplace"
        />
      </Helmet> */
  }

  return (
    <Box width="100%" height="100vh">
      {firstSection}
      <Footer />
    </Box>
  );
};

export default BeautyLandingPage;
